import I18n from 'I18n';
import { fromJS } from 'immutable';
import { useState } from 'react';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { PropertyFilter } from 'customer-data-filters-ui/public/components';
// @ts-expect-error untyped import
import { useField } from '../SourceMeta';
import { useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
// @ts-expect-error untyped import
import { GroupFilterControl } from '../shared/GroupFilterControl';
// @ts-expect-error untyped import
import { CloneFilterSelect } from '../shared/CloneFilterSelect';
import { validateFilterOperatorValue
// @ts-expect-error untyped import
} from '../../filter-validation-utils';
import { htmlEscapedFilter, htmlNormalizedToTextFilter } from '../../filter-utils';
// @ts-expect-error untyped import
import { validateFilterDateRangeValue } from '../../filter-validation-utils';
import { useDatasetFilterStrategy } from '../../strategies/use-dataset-strategy';
// @ts-expect-error untyped import
import { useSourceMeta } from '../SourceMeta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NewFieldFilterPanel = ({
  filter,
  groupId,
  onDone,
  onCancel,
  onCloneFilter
}) => {
  const fieldName = filter.field.name;
  const datasetField = useField(fieldName);
  const [draftFilter, setDraft] = useState(filter);
  const [draftGroupId, setGroup] = useState(groupId);
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const sourceMeta = useSourceMeta();
  const strategy = useDatasetFilterStrategy({
    source: sourceMeta
  });
  let {
    filter: propertyFilter
  } = draftFilter;
  if (datasetField.type === 'html') {
    propertyFilter = htmlNormalizedToTextFilter(draftFilter).filter;
  }
  const handleChange = (value, info) => {
    if (!value || info.hasIncompleteFilters || info.hasFilterValidationErrors) {
      return;
    }
    const nextFilter = filter.set('filter', fromJS(value));
    if (datasetField.type.propertyType === 'html') {
      const updatedFilter = htmlEscapedFilter(nextFilter);
      setDraft(updatedFilter);
    } else {
      setDraft(nextFilter);
    }
  };
  const handleDone = () => {
    onDone({
      draftFilter,
      draftGroupId
    });
  };
  const handleCloneFilter = groupIndex => {
    onCloneFilter({
      draftFilter,
      groupId: groupIndex
    });
  };
  const isValidFilter = validateFilterOperatorValue(draftFilter, userGates);
  const isValidDateRangeValue = validateFilterDateRangeValue(draftFilter);
  const isSubmitDisabled = !isValidFilter || !isValidDateRangeValue;
  const disabledButtonTooltipCopy = I18n.text('reporting-snowflake.filter-editor.editor-panel.incomplete-filter-options');
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "filter-edit-panel",
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlockEnd: "0",
      children: datasetField.label || datasetField.name
    }), /*#__PURE__*/_jsx(GroupFilterControl, {
      currentGroupId: draftGroupId,
      onGroupSelected: nextGroupId => setGroup(nextGroupId)
    }), /*#__PURE__*/_jsx(PropertyFilter, {
      requiredPropertyName: fieldName,
      filterFamily: '0-1',
      onChange: handleChange,
      strategy: strategy,
      value: propertyFilter.toJS(),
      use: "vertical",
      hidePropertySelect: true
    }), /*#__PURE__*/_jsxs(TFlex, {
      justify: "between",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: disabledButtonTooltipCopy,
          placement: "top right",
          disabled: !isSubmitDisabled,
          children: /*#__PURE__*/_jsx(Button, {
            use: "tertiary",
            size: "xs",
            "data-test-id": "filter-editor-panel-apply-btn",
            disabled: isSubmitDisabled,
            onClick: handleDone,
            children: I18n.text('reporting-snowflake.filter-editor.editor-panel.apply')
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          onClick: onCancel,
          children: I18n.text('reporting-snowflake.filter-editor.editor-panel.cancel')
        })]
      }), /*#__PURE__*/_jsx(CloneFilterSelect, {
        currentGroupId: groupId,
        disabled: isSubmitDisabled,
        tooltipMessage: disabledButtonTooltipCopy,
        onCloneFilter: handleCloneFilter
      })]
    })]
  });
};